import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import styled from '@emotion/styled';

interface propsButton {
  variant?: 'text' | 'contained' | 'outlined';
  title?: string;
  icon?: any;
  color?: 'primary' | 'secondary' | 'success' | 'error' | 'warning' | 'info';
  size?: "small" | "large" | "medium";
  onClick?: any;
  type?: any;
  loading?: boolean;
  disabled?: boolean;
  id?: string;
  fullWidth?: boolean;
}

export default function ButtonUI({
  id,
  variant = 'contained',
  title,
  icon,
  color,
  size,
  onClick,
  type,
  disabled = false,
  loading = false,
  fullWidth = false
}: propsButton) {
  return (

      <StyledButton
        fullWidth={fullWidth}
        id={id}
        type={type}
        onClick={onClick}
        size={size}
        color={color}
        variant={variant}
        disabled={disabled || loading}
        startIcon={!loading ? icon : null}
      >
        {loading ? (
          <CircularProgress size={20} color="inherit" />
        ) : (
          title
        )}
      </StyledButton>

  );
}

const StyledButton = styled(Button)(({ theme, color }) => ({
  fontWeight: 'bolder',
  backgroundColor: color === 'primary' ? '#1A455F' : color === 'secondary' ? '#EEEEEE' : 'inherit',
  borderColor: color === 'primary' ? '#fafafa' : color === 'secondary' ? '#43a047' : 'inherit',
  borderRadius: '10px',
  color: color === 'primary' ? '#fafafa' : color === 'secondary' ? '#43a047' : 'inherit',
  '&:hover': {
    backgroundColor: color === 'primary' ? '#00350392' : color === 'secondary' ? '#00001' : 'inherit',
  },
}));
